import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import TablePagination from '@mui/material/TablePagination';
import { textFieldStyle } from "../../../assets/styles/styles";
import { RequestStatus } from "common-frontend-components";
import { rowsPerPageOptions } from "../../../variables/rowsPerPageOptions";
import { sitePhotoStore } from "../../../stores/appConfig/sitePhotoStore";
export const SitePhotosPaginator = () => {
    const request = sitePhotoStore.useStatus();
    const pageIndex = sitePhotoStore.usePageIndex();
    const rowsPerPage = sitePhotoStore.useRowsPerPage();
    const items = sitePhotoStore.useData();
    if (request === RequestStatus.loading)
        return _jsx(_Fragment, {}, void 0);
    return (_jsx(TablePagination, { sx: textFieldStyle, rowsPerPageOptions: rowsPerPageOptions, component: "div", count: items.length, rowsPerPage: rowsPerPage, page: pageIndex, onPageChange: sitePhotoStore.handleChangePage, onRowsPerPageChange: sitePhotoStore.handleChangeRowsPerPage }, void 0));
};
export function IfPageHasItems(Component) {
    return (props) => {
        const pageItems = sitePhotoStore.usePageItems();
        if (pageItems.length === 0)
            return null;
        return (_jsx(Component, { pageItems: pageItems, ...props }, void 0));
    };
}
export const IfPageHasSitePhotosPaginator = IfPageHasItems(() => _jsx(SitePhotosPaginator, {}, void 0));
//# sourceMappingURL=SitePhotosPaginator.js.map